export function resolveTarget(selector, root = document) {
    if (!selector)
        return null;
    // onboard:foo -> [data-onboard-id="foo"]
    if (selector.startsWith('onboard:')) {
        const id = selector.slice('onboard:'.length);
        return root.querySelector(`[data-onboard-id="${CSS.escape(id)}"]`);
    }
    try {
        return root.querySelector(selector);
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=resolveTarget.js.map